import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Pinned top row of `<vx-sidebar>`: brand mark on one side, actions on the
 * other. Mark the brand with the `vxSidebarBrand` attribute — `compact`
 * hides it and pulls the remaining actions in:
 *
 *   <vx-sidebar-header [compact]="collapsed()">
 *     <img vxSidebarBrand … />
 *     <button …>collapse</button>
 *   </vx-sidebar-header>
 *
 * Both are projected; the brand asset is an app concern.
 */
@Component({
  selector: 'vx-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class]': 'classes()' },
})
export class VxSidebarHeaderComponent {
  /** Icon-only row: hides the brand and keeps the actions on the trailing edge. */
  readonly compact = input(false);

  // Compact keeps the actions on the trailing edge; the 15px inset lands them
  // on the same centre line as the nav icons.
  protected readonly classes = computed(
    () =>
      `flex h-16.5 shrink-0 items-center ${
        this.compact() ? 'justify-end ps-3 pe-3.75' : 'justify-between px-3'
      }`,
  );
}
